/** AutoMapa dealer portal i18n — English (en-US). Merged into automotive.dealerPortal at build time. */
export default {
  common: {
    apply: "Apply",
    retry: "Retry",
    back: "Back",
    cancel: "Cancel",
    close: "Close",
    save: "Save",
    edit: "Edit",
    view: "View",
    viewAll: "View all",
    loading: "Loading…",
    whatsapp: "WhatsApp",
    period: "Period",
    quality: "Quality",
    active: "Active",
    public: "Public",
    noTimeline: "No timeline",
    team: "team",
    newCount: "{count} new",
    activeCount: "{count} active",
    alertsCount: "{count} alerts",
    viewOnAutoMapa: "View on AutoMapa",
    noDataInPeriod: "No data in this period.",
    exportCsv: "Export CSV",
    backToDashboard: "Back to dashboard",
    minSuffix: " min",
    viewsCount: "{count} views",
  },
  errors: {
    generic: "Could not load this page.",
    loadDashboard: "Could not load the dashboard.",
    loadLeads: "Could not load leads.",
    loadLead: "Lead not found.",
    loadInventory: "Could not load inventory.",
    loadReports: "Could not load reports.",
    loadPlan: "Could not load your plan.",
    loadOnboarding: "Could not load onboarding.",
    updateOnboarding: "Could not update this onboarding step.",
    loadImport: "Could not load import.",
    updateLead: "Could not update the lead.",
    saveNote: "Could not save the note.",
    actionFailed: "Action failed.",
    duplicateFailed: "Could not duplicate listing.",
    serverUnexpected: "The server encountered an unexpected error. Try again in a moment.",
    network: "Could not reach the server. Check your connection and try again.",
    dealerNotFound: "Dealer not found.",
    loadSponsorships: "Could not load sponsorships.",
    submitUpgrade: "Could not submit your upgrade request.",
    upgrade_pending: "You already have a pending upgrade request for this plan.",
    upgrade_not_higher: "Choose a plan higher than your current plan.",
    upgrade_invalid_plan: "Select a valid plan to upgrade to.",
    authRequired: "Your dealer session expired. Sign in again and retry.",
    accessDenied: "You do not have access to submit an upgrade for this dealership.",
    notFound: "This action is not available right now. Refresh the page or contact AutoMapa if it continues.",
    badRequest: "We could not process this upgrade request. Check your selection and try again.",
    validationFailed: "We could not process this upgrade request. Review the form and try again.",
    http_404: "The upgrade service was not found. The API may need a restart — refresh and try again.",
    http_409: "You already have a pending upgrade request for this plan.",
  },
  sponsorships: {
    title: "Paid marketing boosts",
    subtitle: "Promote vehicles with sponsored placement in AutoMapa search. Boosts are paid add-ons on top of your dealer plan.",
    marketingEyebrow: "Paid marketing",
    marketingTitle: "Reach more buyers with sponsored visibility",
    marketingBody:
      "Search boosts put your vehicles in premium positions when buyers search AutoMapa. This is additional paid marketing — separate from your monthly plan — and each boost runs for a fixed period once approved.",
    marketingPoint1: "You choose the vehicle and placement type before requesting.",
    marketingPoint2: "AutoMapa reviews eligibility, schedules the boost, and labels it clearly as \"Featured\" for buyers.",
    marketingPoint3: "You are billed for each approved boost period. Costs add up as you run more campaigns.",
    pricingTitle: "Boost pricing",
    pricingPerWeek: "{price} / week",
    pricingDefaultDuration: "Typical campaign: {days} days when approved",
    pricingNote: "Final dates and invoice are confirmed by AutoMapa after review. Amounts below are estimates in COP.",
    spendTitle: "Your marketing commitment",
    spendTotal: "Total committed",
    spendActive: "Active boosts (remaining)",
    spendScheduled: "Scheduled boosts",
    spendPending: "Pending requests",
    spendHint: "Cumulative estimated spend for boosts currently running, scheduled, or awaiting approval.",
    spendEmpty: "No paid boosts yet. When you request and approve boosts, your running total will appear here.",
    newBoostEstimate: "This request adds about {price} for {days} days",
    newBoostTotalAfter: "Total commitment after approval: about {price}",
    loading: "Loading sponsorships…",
    viewPlan: "Your plan",
    upgradeCta: "Review plan options",
    totalLikes: "Buyer likes",
    likedVehicles: "{count} vehicles liked",
    activeBoosts: "Active boosts",
    pendingRequests: "Pending requests",
    popularTitle: "Most liked vehicles",
    popularHint: "Ranked by buyer saves (♥) in the last 30 days. Boost active listings to turn interest into visibility.",
    popularEmpty: "No likes yet. When buyers save your vehicles, they will appear here.",
    likes: "Likes",
    boostStatus: "Boost status",
    notBoosted: "Not boosted",
    boost: "Boost",
    cannotBoostInactive: "Activate this listing before boosting",
    manageTitle: "Request a paid search boost",
    manageIntro: "Select a vehicle, choose a placement type, and review the estimated cost before sending your request.",
    selectVehicle: "Choose a vehicle",
    selectVehicleHint: "Search and filter your active inventory, then select a vehicle to boost.",
    vehicleSearchPlaceholder: "Search by vehicle or city…",
    vehicleFilterLabel: "Show",
    vehicleFilterAll: "All active",
    vehicleFilterAvailable: "Available to boost",
    vehicleFilterBoosted: "Already boosted",
    vehicleSortLabel: "Sort",
    vehicleSortAlpha: "Vehicle A–Z",
    vehicleSortPriceAsc: "Price: low to high",
    vehicleSortPriceDesc: "Price: high to low",
    vehicleResultsCount: "{shown} of {total} vehicles",
    vehiclePickerEmpty: "No vehicles match your search. Try a different term or filter.",
    selectedVehicle: "Selected vehicle",
    changeVehicle: "Change",
    stepVehicle: "1. Vehicle",
    stepPlacement: "2. Placement",
    stepReview: "3. Review & send",
    marketingToggle: "How paid boosts work",
    insightsTitle: "Performance insights",
    paginationPrev: "Previous",
    paginationNext: "Next",
    paginationPage: "Page {page} of {total}",
    noBoostableVehicles: "You have no active listings to boost.",
    addInventoryCta: "Add or activate inventory",
    boostType: "Placement type",
    boostTypeHint: "Higher placements cost more because they receive prime visibility.",
    requestNote: "Note for AutoMapa (optional)",
    requestPlaceholder: "Target city, campaign dates, or why this vehicle should be boosted…",
    requestBoost: "Request boost · {price}",
    submitting: "Submitting…",
    requestSent: "Boost request sent. AutoMapa will review pricing and schedule before activation.",
    selectListingRequired: "Select an active vehicle to boost.",
    defaultRequestMessage: "Boost request from dealer portal",
    alreadyBoosted: "boost active",
    activeBoostsTitle: "Active paid boosts",
    noActiveBoosts: "No active boosts right now. Request one for a high-performing vehicle.",
    scheduledTitle: "Scheduled boosts",
    pendingRequestsTitle: "Pending requests",
    recentTitle: "Recent boosts",
    costRemaining: "Remaining: {price}",
    costTotal: "Campaign: {price}",
    costEstimated: "Est. {price}",
    durationDays: "{days} days",
    placementStatus: {
      draft: "Draft",
      scheduled: "Scheduled",
      active: "Active",
      paused: "Paused",
      expired: "Expired",
      cancelled: "Cancelled",
      rejected: "Rejected",
    },
    boostTypes: {
      search_top_slot: {
        label: "Top of search",
        description: "Highest visibility — your vehicle appears at the top of relevant search results.",
      },
      search_inline_slot: {
        label: "Inline search boost",
        description: "Featured placement while buyers scroll search results.",
      },
      featured_listing: {
        label: "Featured listing",
        description: 'Standard sponsored slot with clear "Featured" labeling for buyers.',
      },
    },
  },
  dateRanges: {
    today: "Today",
    last_7_days: "Last 7 days",
    last_30_days: "Last 30 days",
    this_month: "This month",
    trial_period: "Trial period",
  },
  dashboard: {
    loadErrorTitle: "We couldn't load your dashboard",
    heroEyebrow: "Dealer dashboard",
    heroTitle: "Hello, {name}",
    heroIntro: "Summary for {period}. Prioritize hot leads, keep inventory updated, and review performance signals.",
    viewLeads: "View leads",
    reports: "Reports",
    respondLeads: "Respond to leads",
    addVehicle: "Add vehicle",
    reviewInventory: "Review inventory",
    publicProfile: "Public profile",
    emptyTitle: "Start receiving useful signals",
    emptyBody: "Publish active inventory and respond to leads to see funnel, engagement, and quality alerts on this dashboard.",
    importInventory: "Import inventory",
    insightTitle: "Most relevant right now",
    kpiActiveListings: "Active listings",
    kpiNewLeads: "New leads",
    kpiHotLeads: "Hot leads",
    kpiLeadsInPeriod: "Leads in period",
    kpiWhatsappClicks: "WhatsApp clicks",
    kpiResponseTime: "Response time",
    hotLeadsTitle: "Hot leads",
    hotLeadsEmpty: "No hot leads in this period. Review new leads and respond quickly.",
    viewLead: "View lead",
    funnelTitle: "Lead funnel",
    funnelInPeriod: "{count} in period",
    funnelNew: "New",
    funnelContacted: "Contacted",
    funnelTestDrive: "Test drive",
    funnelNegotiating: "Negotiating",
    funnelSold: "Sold",
    conversionRate: "Conversion: {rate}%",
    topListingsTitle: "Top vehicles",
    topListingsEmpty: "Publish active inventory to see performance by vehicle.",
    popularTitle: "Most liked by buyers",
    popularEmpty: "When buyers heart your listings, popular vehicles will show here.",
    popularHint: "Based on buyer saves in this period.",
    viewSponsorships: "Manage boosts",
    likesCount: "{count} likes",
    checklistTitle: "Recommended actions",
    checklistComplete: "All main tasks are up to date.",
    alertsTitle: "Inventory alerts",
    alertsEmpty: "No urgent operational alerts.",
    profileHealthTitle: "Profile health",
    inventoryEngagementTitle: "Inventory & engagement",
    statActive: "Active",
    statPublic: "Public",
    statMissingPhotos: "Missing photos",
    statListingViews: "Listing views",
  },
  leads: {
    inboxTitle: "Lead inbox",
    hotTitle: "Hot leads",
    archivedTitle: "Archived leads",
    inboxSubtitle: "Buyers interested in your inventory and matching requests.",
    allNew: "All",
    hot: "Hot",
    contacted: "Contacted",
    testDrives: "Test drives",
    sold: "Sold",
    archived: "Archived",
    searchPlaceholder: "Search name, phone, city…",
    allStatuses: "All statuses",
    sourcePage: "Source (page)",
    campaign: "Campaign",
    leadsReport: "Lead report",
    loading: "Loading leads…",
    empty: "You don't have leads yet. When a buyer contacts your vehicles or completes a matching request, they will appear here.",
    updateFailed: "Could not update the lead.",
    hotPill: "Hot",
    actionPlaceholder: "Action…",
    table: {
      buyer: "Buyer",
      whatsapp: "WhatsApp",
      type: "Type",
      status: "Status",
      score: "Score",
      temperature: "Temperature",
      vehicleInterest: "Vehicle / interest",
      city: "City",
      timeline: "Timeline",
      date: "Date",
      actions: "Actions",
    },
  },
  inventory: {
    searchPlaceholder: "Search make/model",
    allStatuses: "All statuses",
    addVehicle: "Add vehicle",
    importCsv: "Import CSV",
    loading: "Loading inventory…",
    empty: "You don't have published vehicles yet. Add your first vehicle to start receiving qualified buyers.",
    photo: "Photo",
    vehicle: "Vehicle",
    price: "Price",
    mileage: "Mileage",
    city: "City",
    status: "Status",
    availability: "Availability",
    fairPrice: "Fair price",
    risk: "Risk",
    actions: "Actions",
    confirm: "Confirm",
    reserve: "Reserve",
    soldAction: "Sold",
    pause: "Pause",
    duplicate: "Duplicate",
    pageSubtitle: "Review, update, and manage the vehicles buyers see on AutoMapa.",
    sortLabel: "Sort",
    resultsCount: "{count} vehicles",
    moreActions: "More",
    viewPublic: "View on AutoMapa",
    publicListingUnavailable: "Public listing unavailable",
    publicListingSyncPending: "Public listing is still syncing",
    noPhoto: "No photo",
  },
  inventoryDetail: {
    loading: "Loading vehicle…",
    notFound: "Vehicle not found.",
    backToInventory: "← Inventory",
    editListing: "Edit listing",
    viewPublic: "View on AutoMapa",
    featuredActive: "Featured placement active",
    featuredUntil: "Until {date}",
    requestFeatured: "Request featured",
    photosTitle: "Gallery",
    noPhotos: "No photos — add images to improve conversion.",
    managePhotosTitle: "Manage photos",
    managePhotosIntro:
      "Add, reorder, or remove images. The first photo is the cover image in search and on the public page.",
    savePhotos: "Save photos",
    savingPhotos: "Saving photos…",
    savePhotosFailed: "Could not save photos.",
    statsViews: "Views",
    statsLeads: "Leads",
    statsQuality: "Quality",
    statsLastConfirmed: "Last confirmed",
    neverConfirmed: "Not confirmed yet",
    specsTitle: "Vehicle details",
    transmission: "Transmission",
    fuel: "Fuel",
    bodyType: "Body type",
    color: "Color",
    version: "Trim",
    descriptionTitle: "Description",
    noDescription: "No description yet. Add details to help buyers decide.",
    warningsTitle: "Needs attention",
    fairPriceTitle: "Market pricing",
    fairPriceLabel: "Label",
    fairPriceMedian: "Comparable median",
    fairPriceComparables: "Comparables",
    fairPriceDelta: "Delta vs market",
    fairPriceHighHint:
      "This price is above similar listings. Highlight benefits in the description.",
    riskTitle: "Review signals",
    riskIntro: "Fix these signals to improve trust and conversion.",
    riskNone: "No pending signals.",
    riskEditLink: "Edit listing",
    riskQualityLink: "View inventory quality",
    buyerSection: "Buyer interest",
    workflowTitle: "Listing status",
    workflowIntro: "Keep inventory fresh to build buyer trust.",
    confirmAvailable: "Confirm available",
    markReserved: "Mark reserved",
    markSold: "Mark sold",
    pause: "Pause listing",
    reactivate: "Reactivate",
    archive: "Archive",
    actionFailed: "Action failed.",
  },
  inventoryForm: {
    addTitle: "Add vehicle",
    editTitle: "Edit vehicle",
    loading: "Loading vehicle…",
    backToListing: "Back to listing",
    backToInventory: "Back to inventory",
    qualityScore: "Listing quality",
    intro:
      "Use the side menu to jump between sections. Fields marked * are required to publish.",
    sectionNavTitle: "Sections",
    sidebarTitle: "Help & actions",
    actionsTitle: "Save changes",
    expandSection: "Show",
    collapseSection: "Hide",
    tipsTitle: "Quick tips",
    tips: {
      photos: "📸 At least 3 clear photos (exterior, interior, dashboard).",
      price: "💰 Accurate price and mileage build buyer trust.",
      docs: "📋 Valid SOAT and technical inspection improve listing quality.",
    },
    sections: {
      photos: "Photos",
      vehicle: "Vehicle",
      sale: "Price & location",
      listing: "Listing copy",
      documents: "Documents",
      identity: "Vehicle identification",
      pricing: "Price & availability",
      specs: "Technical specifications",
      location: "Vehicle location",
    },
    sectionDescriptions: {
      photos: "Photo #1 is the cover in search. Add at least 3 clear photos.",
      vehicle: "Make, model, year, and mechanical specs in one place.",
      sale: "Price, availability, and where buyers can see the vehicle.",
      listing: "Sales description and internal references for your team.",
      documents: "Internal compliance. Plate and VIN are not shown publicly.",
      identity: "Core vehicle data. Should match the title or invoice.",
      pricing: "Commercial info shown on AutoMapa. Enter price in Colombian pesos (COP).",
      specs: "Mechanical details buyers use to filter and compare.",
      location: "Where the vehicle can be viewed or picked up. Improves local search relevance.",
    },
    sectionEmojis: {
      photos: "📸",
      vehicle: "🚗",
      sale: "💰",
      listing: "✍️",
      documents: "📋",
      identity: "🚗",
      pricing: "💰",
      specs: "⚙️",
      location: "📍",
    },
    documentPrivacyNote: "🔒 Plate, VIN, and internal stock # are dealer-only — they do not appear on the public listing.",
    photos: {
      helper: "The first photo is the cover on AutoMapa. Add at least 3 photos to improve conversion.",
      empty: "No photos yet. Upload from your computer or paste image URLs.",
      primaryBadge: "Cover",
      addUrl: "Add URL",
      orAddUrl: "Or paste a URL",
      addUrlPlaceholder: "https://example.com/photo.jpg",
      uploadHint: "JPG, PNG, or WebP · max 8 MB each · up to 20 photos.",
      uploadFiles: "📤 Upload photos",
      uploadingFiles: "Uploading…",
      uploadedFileNote: "File uploaded from your device.",
      uploadedFilePlaceholder: "Locally uploaded photo",
      moveUp: "Move up",
      moveDown: "Move down",
      setPrimary: "Set as cover",
      remove: "Remove",
      count: "{count} photo(s)",
      invalidUrl: "Enter a valid URL (http:// or https://).",
      tooMany: "You can add up to 20 photos per vehicle.",
      tooLarge: "Each photo must be under 8 MB.",
      invalidType: "Only JPG, PNG, or WebP images are allowed.",
      emptyFile: "The file is empty.",
      uploadFailed: "Could not process the image. Try another file.",
    },
    saveDraft: "Save draft",
    save: "Save",
    saveAndPublish: "Save & publish",
    documentStatus: {
      valid: "Valid",
      expired: "Expired",
      unknown: "Unknown",
      not_provided: "Not provided",
    },
    fields: {
      make: "Make",
      model: "Model",
      version: "Trim / version",
      year: "Year",
      priceCop: "Price (COP)",
      mileageKm: "Mileage (km)",
      transmission: "Transmission",
      fuel: "Fuel",
      bodyType: "Body type",
      color: "Color",
      engineSize: "Engine size",
      doors: "Doors",
      city: "City",
      neighborhood: "Neighborhood",
      address: "Address",
      availabilityStatus: "Availability",
      description: "Description",
      financingAvailable: "Financing available",
      internalPlate: "Plate (internal)",
      internalVin: "VIN (internal)",
      soatStatus: "SOAT",
      tecnomecanicaStatus: "Technical inspection",
      ownershipCount: "Number of owners",
      accidentHistoryNote: "Accident history",
      dealerStockNumber: "Internal stock #",
      externalListingUrl: "External listing URL",
    },
    fieldHints: {
      make: "e.g. Toyota, Renault, Chevrolet — as buyers know the brand.",
      model: "Vehicle line: Corolla, Duster, Onix…",
      version: "Trim or version (XLE, Sport, LTZ). Optional if N/A.",
      year: "Model year per title or invoice.",
      bodyType: "SUV, sedan, pickup… helps search filters.",
      priceCop: "Asking price in pesos. Numbers only, no symbols.",
      mileageKm: "Current odometer reading in kilometers.",
      availabilityStatus: "Can buyers view or take delivery soon?",
      financingAvailable: "Check if you offer credit, leasing, or payment plans.",
      transmission: "Manual, automatic, or CVT as applicable.",
      fuel: "Gasoline, diesel, hybrid, electric, or CNG.",
      engineSize: "e.g. 1600 cc, 2.0L — optional but helps comparison.",
      doors: "Door count (include hatch/tailgate on SUVs).",
      color: "Primary exterior color visible in photos.",
      city: "City where the vehicle is located for viewings.",
      neighborhood: "Neighborhood or area — improves local search.",
      address: "Optional. Lot address or handoff point.",
      internalPlate: "Internal reference. Not published on AutoMapa.",
      internalVin: "Chassis number for inventory control. Not public.",
      soatStatus: "Mandatory insurance: valid, expired, or unknown.",
      tecnomecanicaStatus: "Technical-mechanical inspection status.",
      ownershipCount: "Previous owners plus current. 1 = first owner.",
      accidentHistoryNote: "Collisions or major repairs. Be transparent.",
      description: "Equipment, condition, warranty, and why this vehicle stands out.",
      dealerStockNumber: "Your dealership inventory code (internal SKU).",
      externalListingUrl: "Link to your website or marketplace if listed elsewhere.",
    },
    required: " *",
  },
  reports: {
    nav: {
      hub: "Overview",
      rendimiento: "Listings",
      leads: "Leads",
      inventario: "Inventory",
      fuentes: "Sources",
    },
    hubTitle: "Performance reports",
    hubDescription: "Track views, contacts, leads, and inventory on AutoMapa.",
    loading: "Loading reports…",
    listingViews: "Listing views",
    whatsappClicks: "WhatsApp clicks",
    leadsReceived: "Leads received",
    qualifiedLeads: "Qualified leads",
    activeInventory: "Active inventory",
    inventoryFreshness: "Inventory freshness",
    avgResponseTime: "Average response time",
    insufficientResponseData: "Not enough data",
    featuredPlacement: "Featured placement",
    featuredIntro: "These results show interactions from featured placements on AutoMapa.",
    impressions: "Impressions",
    clicks: "Clicks",
    topFeatured: "Top featured",
    trialPerformance: "Trial performance",
    daysRemaining: "Days remaining",
    views: "Views",
    inventoryFreshnessPct: "Inventory freshness",
    exploreReports: "Explore reports",
    listingPerformance: "Listing performance",
    listingPerformanceDesc: "Views, WhatsApp, leads, and suggested actions by vehicle.",
    leadPerformance: "Lead performance",
    leadPerformanceDesc: "Quality, sources, response time, and performance by listing.",
    inventoryReport: "Inventory",
    inventoryReportDesc: "Quality, freshness, and listings that need action.",
    sourcesReport: "Sources",
    sourcesReportDesc: "Where your leads and contact clicks come from.",
    recommendedActions: "Recommended actions",
    respondLeads: "Respond to leads",
    updateInventory: "Update inventory",
    viewsOverTime: "Views over time",
    whatsappOverTime: "WhatsApp clicks over time",
    leadsOverTime: "Leads over time",
    demoNotice: "Showing sample report data. Live metrics appear once your plan includes performance reports and you have activity on AutoMapa.",
    demoTopListing: "2022 Toyota Corolla Cross",
    cannedActions: {
      respondLeads: "Respond to new leads within 2 hours to improve conversion.",
      updatePhotos: "Add photos to listings missing images.",
      confirmInventory: "Confirm availability on vehicles not updated in 14+ days.",
    },
  },
  onboarding: {
    title: "Set up your dealership",
    subtitle: "Complete these steps to start receiving qualified buyers on AutoMapa.",
    eyebrow: "Getting started",
    loading: "Loading your onboarding checklist…",
    progress: "Readiness score",
    status: "Status",
    activeListings: "Active listings",
    photoCoverage: "Photo coverage",
    freshness: "Availability confirmed",
    launchTarget: "Launch target",
    metricsTitle: "Launch metrics",
    checklistTitle: "Your checklist",
    checklistProgress: "{percent}% of required steps complete",
    stepsComplete: "{completed} of {total} steps complete",
    sectionProgress: "{completed} of {total} done in this section",
    stepComplete: "Complete",
    stepPending: "To do",
    nextUp: "Recommended next step",
    markComplete: "Mark as done",
    markingComplete: "Saving…",
    adminReviewNote: "AutoMapa will confirm this step after review.",
    helpTitle: "Need help?",
    helpBody: "Upload inventory, confirm availability weekly, and respond to leads quickly. AutoMapa support can help with profile updates and verification.",
    launchReadyTitle: "You're launch-ready",
    nextStepsTitle: "Next steps",
    ctaUploadInventory: "Upload inventory",
    ctaConfirmAvailability: "Confirm availability",
    ctaReviewLeads: "Review leads",
    ctaViewReports: "View reports",
    launchReady: "Your dealership meets the initial requirements to receive buyers on AutoMapa.",
    selectDealer: "Select a dealership in the portal.",
    metricActiveListings: "{current} of {target} active listings published",
    metricPhotoCoverage: "{current}% of listings have photos (target {target}%)",
    metricFreshness: "{current}% confirmed available recently (target {target}%)",
    categories: {
      business_profile: "Dealership profile",
      contact_channels: "Contact & WhatsApp",
      verification: "Verification",
      inventory: "Inventory setup",
      photos: "Listing photos",
      leads: "Leads & routing",
      training: "Portal training",
      launch_readiness: "Launch approval",
    },
    hints: {
      business_name_confirmed: "Make sure your public dealership name matches what buyers know.",
      public_name_confirmed: "Review how your name appears on your public AutoMapa profile.",
      logo_added: "Add a logo or cover photo so buyers recognize your brand.",
      address_confirmed: "Confirm your physical address for trust and local search.",
      city_neighborhood_confirmed: "Buyers filter by city — confirm yours is correct.",
      whatsapp_confirmed: "Your primary WhatsApp receives buyer lead notifications.",
      contact_person_confirmed: "Identify who responds to leads from your team.",
      public_profile_reviewed: "Open your public profile and check that details look correct.",
      verification_reviewed: "AutoMapa verifies dealership identity before full launch.",
      inventory_file_received: "Share a CSV or spreadsheet with your current used inventory.",
      inventory_imported: "Import vehicles into the portal or publish them manually.",
      listings_cleaned: "Fix missing fields and low-quality listings before launch.",
      listings_have_photos: "Listings without photos are hidden from buyers.",
      listings_have_price_mileage: "Every listing needs price and mileage for search filters.",
      listings_confirmed_available: "Confirm vehicles are still for sale at least every two weeks.",
      min_ten_active_listings: "Publish at least ten active vehicles to appear credible to buyers.",
      lead_inbox_reviewed: "Open your lead inbox and review any new buyer requests.",
      whatsapp_routing_tested: "Send a test lead to confirm WhatsApp notifications arrive.",
      dashboard_reviewed: "Review your dashboard metrics and alerts.",
      response_expectations_understood: "Respond to new leads within two hours when possible.",
      trial_terms_explained: "Review your plan limits and trial terms.",
      launch_ready_approval: "AutoMapa gives final launch approval once all requirements are met.",
    },
    actions: {
      reviewProfile: "Review public profile",
      contactAutoMapa: "Contact AutoMapa",
      uploadInventory: "Upload inventory",
      reviewQuality: "Review listing quality",
      addPhotos: "Add missing photos",
      fixListings: "Fix listing data",
      confirmAvailability: "Confirm availability",
      addVehicles: "Add vehicles",
      openLeads: "Open leads",
      testWhatsapp: "Test WhatsApp routing",
      openDashboard: "Open dashboard",
      readGuide: "Read response guide",
      reviewPlan: "Review your plan",
      awaitingApproval: "Awaiting AutoMapa review",
      getStarted: "Get started",
    },
  },
  readiness: {
    not_started: "Not started",
    in_progress: "In progress",
    needs_inventory: "Needs inventory",
    needs_verification: "Needs verification",
    needs_cleanup: "Needs cleanup",
    launch_ready: "Launch ready",
    active: "Active",
  },
  plan: {
    title: "Your plan",
    subtitle: "Limits, included features, and monthly usage.",
    pageEyebrow: "💼 Billing & plans",
    subtitleProfessional: "See what your dealership has today, how much you're using, and clear upgrade paths with pricing.",
    loading: "Loading your plan…",
    contactAutoMapa: "💬 Contact AutoMapa",
    viewReports: "📊 View reports",
    updateInventory: "Update inventory",
    openLeads: "Open leads",
    activeListings: "Active listings",
    leadsThisMonth: "Leads this month",
    reportsAccess: "Reports",
    featuredEligible: "Featured placement",
    featuredEligibleYes: "Eligible",
    notIncluded: "Not included",
    currentPlanTitle: "✅ Your current plan",
    currentPlanBadge: "Current plan",
    currentPlanFootnote: "This is the plan active on your account today.",
    usageTitle: "📈 Monthly usage",
    upgradeTitle: "🚀 Upgrade options",
    upgradeSubtitle: "Compare plans with pricing and features. Upgrades are activated by the AutoMapa team.",
    upgradeCta: "Request upgrade",
    upgradeToPlan: "Upgrade to {plan}",
    upgradeModalEyebrow: "Plan upgrade",
    upgradeModalTitle: "Upgrade your dealership plan",
    upgradeModalPlanIntro: "Choose the plan that fits your inventory and lead volume. We'll confirm pricing and activate your upgrade.",
    upgradeContinue: "Continue",
    upgradeBack: "Back",
    upgradeSubmit: "Submit upgrade request",
    upgradeSubmitting: "Submitting…",
    upgradeDone: "Done",
    upgradeSelectPlanRequired: "Select a plan to continue.",
    upgradeReasonsIntro: "Tell us what you're looking for so we can prepare the right upgrade.",
    upgradeMessageLabel: "Anything else we should know? (optional)",
    upgradeMessagePlaceholder: "Inventory size, launch timeline, billing contact, or special needs…",
    upgradeComparisonTitle: "What changes with this upgrade",
    upgradeTargetLabel: "Requested plan",
    upgradeEstimatedPrice: "Reference price",
    upgradeReviewNote: "AutoMapa reviews every upgrade request manually. You'll receive confirmation before any billing changes.",
    upgradeSuccessTitle: "Upgrade request sent",
    upgradeSuccessBody: "Your request is in the AutoMapa queue. No plan changes happen until we confirm with you.",
    upgradeSuccessStep1: "Our team reviews your inventory size, lead volume, and requested plan.",
    upgradeSuccessStep2: "We confirm final pricing and send billing details if needed.",
    upgradeSuccessStep3: "Your new plan is activated in the portal once approved.",
    upgradePendingTitle: "Upgrade request in progress",
    upgradePendingBody: "You already requested {plan}. AutoMapa is reviewing it — we'll contact you soon.",
    upgradePendingBanner: "Upgrade to {plan} requested on {date}. We're reviewing your request.",
    upgradeReasons: {
      more_listings: "I need to publish more vehicles",
      more_leads: "I'm reaching my monthly lead limit",
      featured_placement: "I want featured placement and paid boosts",
      performance_reports: "I need performance reports",
      bulk_upload: "I need bulk CSV import",
      priority_support: "I want priority support",
    },
    upgradeWhatsappMessage: "Hi AutoMapa, I'd like to upgrade my dealership to the {planName} plan.",
    recommendedBadge: "🌟 Most popular",
    topTierTitle: "You're on our highest standard plan",
    topTierBody: "Need custom limits or enterprise terms? AutoMapa can tailor a custom plan for your group.",
    warningsTitle: "Plan alerts",
    featuredSectionTitle: "⭐ Featured listings",
    featuredRequestLabel: "Request featuring for a listing",
    featuredUpgradeHint: "Upgrade to Growth or Premium to unlock featured placement on AutoMapa.",
    lockedFeaturesTitle: "🔒 Features not on your plan",
    priceFree: "Free",
    priceMonthly: "{price} / month",
    billingNote: "Billing is handled manually by AutoMapa during this phase. No automatic charges in the portal yet.",
    faqTitle: "❓ Plan FAQ",
    faqBillingQuestion: "How does billing work?",
    faqBillingAnswer: "There is no automatic checkout yet. AutoMapa confirms pricing, sends an invoice, and activates your new plan manually.",
    faqUpgradeQuestion: "How do I upgrade?",
    faqUpgradeAnswer: "Choose a plan and click Request upgrade. You'll walk through a short form in the portal — no WhatsApp required. AutoMapa confirms pricing and activates your new plan manually.",
    faqLimitsQuestion: "What happens if I exceed limits?",
    faqLimitsAnswer: "Existing active listings stay live, but you may not publish more until you upgrade. Leads continue to be captured.",
    featureSeoPage: "SEO dealer page",
    featurePrioritySupport: "Priority support",
    featureBulkUpload: "Bulk CSV upload",
    planEmojis: {
      free: "🆓",
      starter: "🌱",
      growth: "🚀",
      premium: "💎",
      custom: "🛠️",
    },
    featuredTitle: "Featured listings",
    featuredActive: "Active",
    featuredScheduled: "Scheduled",
    featuredIntro: "These results show interactions from featured placements on AutoMapa.",
    featuredRequestPlaceholder: "Message to request featuring a listing",
    requestFeatured: "Request featuring",
    requestSent: "Request sent. AutoMapa will review it soon.",
    featuredUpgrade: "Your current plan does not include featured listings. Contact AutoMapa to review options.",
    featuredUpgradeCta: "Request upgrade for featured listings",
    lockedBulkTitle: "Bulk upload",
    lockedBulkDesc: "Your plan does not include CSV bulk import. Contact AutoMapa to upgrade.",
    lockedReportsTitle: "Performance reports",
    lockedReportsDesc: "Full reports require a higher plan.",
    comparisonTitle: "Plan comparison",
    comparisonPricingNote: "Reference monthly pricing in COP. Final pricing is confirmed with AutoMapa sales.",
    colPlan: "Plan",
    colListings: "Listings",
    colLeads: "Leads/mo",
    colBulk: "Bulk",
    colReports: "Reports",
    colFeatured: "Featured",
    colPrice: "Price",
    priceContact: "Contact us",
    unlimited: "Unlimited",
    featureYes: "Yes",
    featureNo: "No",
    trialLabel: "Trial",
    trialStage: "Stage",
    reportsBasic: "Basic",
    reportsFull: "Full",
    featuredDefaultRequest: "Request from dealer portal",
    trialStatus: {
      not_started: "Not started",
      active: "Active",
      ending_soon: "Ending soon",
      expired: "Expired",
      extended: "Extended",
      converted: "Converted",
      lost: "Lost",
      paused: "Paused",
      declined: "Declined",
    },
    conversionStage: {
      no_conversation: "No conversation",
      value_review_scheduled: "Review scheduled",
      value_review_completed: "Review completed",
      pricing_discussed: "Pricing discussed",
      proposal_sent: "Proposal sent",
      negotiation: "Negotiation",
      converted: "Converted",
      lost: "Lost",
    },
    planLabels: {
      free: "Free",
      starter: "Starter",
      growth: "Growth",
      premium: "Premium",
      custom: "Custom",
    },
  },
  import: {
    steps: {
      upload: "Upload file",
      map: "Map fields",
      preview: "Preview",
      confirm: "Confirm",
      results: "Results",
    },
    modes: {
      create_only: "Create new listings only",
      update_by_stock: "Update by stock code",
      update_by_url: "Update by external URL",
      update_by_plate: "Update by internal plate",
      create_and_update: "Create and update",
    },
    publishModes: {
      draft: "Import as draft",
      needs_review: "Send for review",
      active: "Publish valid rows immediately",
    },
    status: {
      uploaded: "Uploaded",
      mapping_required: "Mapping required",
      preview_ready: "Ready to review",
      importing: "Importing…",
      completed: "Completed",
      completed_with_errors: "Completed with errors",
      failed: "Failed",
      cancelled: "Cancelled",
    },
    duplicates: {
      exact_stock_match: "Exact match (stock)",
      exact_url_match: "Exact match (URL)",
      exact_plate_match: "Exact match (plate)",
      likely_duplicate: "Likely duplicate",
      possible_duplicate: "Possible duplicate",
      no_match: "No match",
    },
    rowActions: {
      create: "Create",
      update: "Update",
      skip: "Skip",
      needs_review: "Review",
    },
    fields: {
      make: "Make",
      model: "Model",
      version: "Trim",
      year: "Year",
      priceCop: "Price (COP)",
      mileageKm: "Mileage",
      transmission: "Transmission",
      fuel: "Fuel",
      bodyType: "Body type",
      color: "Color",
      city: "City",
      neighborhood: "Neighborhood",
      address: "Address",
      description: "Description",
      financingAvailable: "Financing",
      photoUrls: "Photo URLs",
      engineSize: "Engine size",
      doors: "Doors",
      internalPlate: "Internal plate",
      internalVin: "Internal VIN",
      soatStatus: "SOAT",
      tecnomecanicaStatus: "Technical inspection",
      ownershipCount: "Owners",
      accidentHistoryNote: "Accident note",
      dealerStockNumber: "Stock code",
      externalListingUrl: "External URL",
      availabilityStatus: "Availability",
      lastConfirmedAt: "Last confirmed",
    },
    fieldRequired: " *",
    fieldRecommended: " (recommended)",
    unmapped: "— Not mapped —",
    samplePrefix: "Example:",
    noSample: "No sample",
    title: "Import inventory",
    subtitle: "Upload a CSV with your vehicles. Download the official AutoMapa template.",
    viewHistory: "View history",
    instructionsTitle: "Instructions",
    instructionTemplate: "Use the CSV template to avoid format errors.",
    instructionNormalize: "Thousands separators in price and mileage are normalized automatically.",
    instructionPhotos: "Photos: URLs separated by comma, semicolon, pipe, or newline.",
    instructionFinancing: "Financing: yes / no / true / false.",
    instructionMaxRows: "Maximum 500 rows per file.",
    downloadTemplate: "Download CSV template",
    csvFile: "CSV file",
    importMode: "Import mode",
    publishMode: "Publish mode",
    confirmCheckbox: "I confirm this information matches the dealership's current inventory.",
    processing: "Processing…",
    continue: "Continue",
    selectFile: "Select a CSV file.",
    confirmRequired: "Confirm that the information matches current inventory.",
    expectedColumns: "Expected columns ({count})",
    historyTitle: "Import history",
    historySubtitle: "Previous CSV imports and their status.",
    newImport: "New import",
    noImports: "No imports recorded yet.",
    importInventory: "Import inventory",
    loadHistoryError: "Could not load import history.",
    tableDate: "Date",
    tableFile: "File",
    tableStatus: "Status",
    tableRows: "Rows",
    tableCreated: "Created",
    tableUpdated: "Updated",
    tableSkipped: "Skipped",
    tableErrors: "Errors",
    tableUploadedBy: "Uploaded by",
    viewDetail: "View detail",
    loadingImport: "Loading import…",
    importNotFound: "Import not found.",
    downloadErrors: "Download errors CSV",
    history: "History",
    modeLabel: "Mode",
    publishLabel: "Publish",
    mapColumnsTitle: "Map columns",
    mapColumnsDesc: "Assign each required field to a column in the file.",
    generatePreview: "Generate preview",
    previewTitle: "Preview",
    previewDesc: "Review valid rows, warnings, and duplicates.",
    saveActions: "Save actions",
    confirmImport: "Confirm import",
    importing: "Importing…",
    resultsTitle: "Results",
    resultsSummary: "Created: {created} · Updated: {updated} · Skipped: {skipped} · Errors: {errors}",
    viewInventory: "View inventory",
    rowLink: "Row {row}: {action} → listing",
    summaryTotalRows: "Total rows",
    summaryValid: "Valid",
    summaryWarnings: "With warnings",
    summaryErrors: "With errors",
    summaryDuplicates: "Possible duplicates",
    summaryCreated: "Created",
    summaryUpdated: "Updated",
    summarySkipped: "Skipped",
    previewEmpty: "No rows to display.",
    previewColNumber: "#",
    previewColVehicle: "Vehicle",
    previewColPrice: "Price",
    previewColMileage: "Mileage",
    previewColCity: "City",
    previewColStatus: "Status",
    previewColWarnings: "Warnings",
    previewColErrors: "Errors",
    previewColDuplicate: "Duplicate",
    previewColAction: "Action",
  },
  login: {
    eyebrow: "AutoMapa · Dealers",
    title: "Sign in",
    subtitle: "Manage your dealership inventory and leads.",
    email: "Email",
    password: "Password",
    submitting: "Signing in…",
    submit: "Sign in",
    backToAutoMapa: "Back to AutoMapa",
    errors: {
      signInFailed: "Could not sign in.",
      invalidCredentials: "Invalid email or password.",
    },
  },
  leadStatus: {
    new: "New",
    routed: "Routed",
    whatsapp_opened: "WhatsApp opened",
    contacted: "Contacted",
    no_response: "No response",
    test_drive_scheduled: "Test drive scheduled",
    negotiating: "Negotiating",
    sold: "Sold",
    lost: "Lost",
    bad_lead: "Low quality",
    archived: "Archived",
  },
  leadTemperature: {
    alta_intencion: "High intent",
    buena_oportunidad: "Good opportunity",
    explorando_opciones: "Exploring options",
    investigacion_inicial: "Initial research",
  },
  leadType: {
    listing_inquiry: "Vehicle inquiry",
    quiz_request: "Quiz request",
    recommendation_inquiry: "Recommendation",
    dealer_contact: "Dealer contact",
    financing_interest: "Financing",
    test_drive_request: "Test drive",
    video_request: "Video",
    price_request: "Price",
    availability_request: "Availability",
  },
  leadOutcome: {
    not_set: "Not set",
    contacted: "Contacted",
    no_response: "No response",
    test_drive_scheduled: "Test drive scheduled",
    negotiating: "Negotiating",
    sold: "Sold",
    lost_price: "Lost — price",
    lost_financing: "Lost — financing",
    lost_vehicle_unavailable: "Lost — vehicle unavailable",
    lost_buyer_not_ready: "Lost — buyer not ready",
    bad_contact_info: "Bad contact info",
    duplicate_lead: "Duplicate",
    spam_or_fake: "Spam or fake",
    other: "Other",
  },
  leadQuality: {
    excellent: "Excellent",
    good: "Good",
    okay: "Okay",
    poor: "Poor",
    bad: "Very poor",
  },
  leadQualityTag: {
    serious_buyer: "Serious buyer",
    correct_budget: "Correct budget",
    ready_to_buy: "Ready to buy",
    good_contact_info: "Good contact",
    wrong_budget: "Wrong budget",
    did_not_respond: "Did not respond",
    bad_phone_number: "Bad phone number",
    vehicle_unavailable: "Vehicle unavailable",
    too_far_away: "Too far away",
    not_interested: "Not interested",
    duplicate: "Duplicate",
    spam: "Spam",
  },
  leadQuickAction: {
    contacted: "Contacted",
    no_response: "No response",
    test_drive_scheduled: "Test drive",
    negotiating: "Negotiating",
    sold: "Sold",
    lost: "Lost",
    bad_lead: "Low quality",
    archived: "Archive",
  },
  leadSort: {
    newest: "Newest",
    oldest: "Oldest",
    score_desc: "Highest score",
    updated_desc: "Recently updated",
    timeline_urgent: "Most urgent timeline",
  },
  listingStatus: {
    draft: "Draft",
    active: "Active",
    needs_review: "Review",
    paused: "Paused",
    sold: "Sold",
    archived: "Archived",
    rejected: "Rejected",
    available: "Available",
    pending_confirmation: "Confirm",
    reserved: "Reserved",
    unknown: "Unknown",
  },
  inventorySort: {
    updated_desc: "Recently updated",
    created_desc: "Newest",
    price_desc: "Highest price",
    price_asc: "Lowest price",
    year_desc: "Newest year",
    mileage_asc: "Lowest mileage",
    quality_asc: "Lowest quality",
  },
  trialReadiness: {
    strong_candidate: "Strong candidate",
    needs_more_leads: "Needs more leads",
    needs_inventory_cleanup: "Inventory needs work",
    poor_response: "Slow response",
    insufficient_data: "Insufficient data",
  },
  listingAction: {
    add_photos: "Add photos",
    confirm_availability: "Confirm availability",
    improve_description: "Improve description",
    review_price: "Review price",
    respond_leads: "Respond to leads",
    mark_sold: "Mark as sold",
    edit_listing: "Edit listing",
  },
  server: {
    responseTimePlaceholder: "Will be calculated once you start updating lead statuses.",
    checklist: {
      confirm_inventory: "Confirm vehicle availability",
      add_photos: "Add missing photos",
      respond_leads: "Respond to new leads",
      update_outcomes: "Update leads without outcome",
      complete_profile: "Complete dealer profile",
      review_quality: "Review low-quality vehicles",
      upload_inventory: "Upload new inventory",
    },
    alerts: {
      needs_confirmation: {
        message: {
          one: "{count} vehicle needs availability confirmation",
          other: "{count} vehicles need availability confirmation",
        },
        action: "Confirm inventory",
      },
      missing_photos: {
        message: {
          one: "{count} vehicle without photos",
          other: "{count} vehicles without photos",
        },
        action: "Add photos",
      },
      missing_price_mileage: {
        message: {
          one: "{count} vehicle missing price or mileage",
          other: "{count} vehicles missing price or mileage",
        },
        action: "Review inventory",
      },
      low_quality: {
        message: {
          one: "{count} vehicle with low quality (< 70)",
          other: "{count} vehicles with low quality (< 70)",
        },
        action: "Improve quality",
      },
      sold_still_public: {
        message: {
          one: "{count} sold listing still visible",
          other: "{count} sold listings still visible",
        },
        action: "Fix status",
      },
      recent_imports: {
        message: {
          one: "{count} recent import",
          other: "{count} recent imports",
        },
        action: "View imports",
      },
    },
    profileHealth: {
      labels: {
        excellent: "Excellent",
        good: "Good",
        needsWork: "Needs improvement",
        incomplete: "Incomplete",
      },
      items: {
        verified: "Verified",
        verificationPending: "Verification pending",
        publicProfile: "Public profile visible",
        logo: "Logo",
        cover: "Cover image",
        description: "Description",
        address: "City / address",
        whatsapp: "WhatsApp",
        financing: "Financing configured",
        listings: "Active inventory",
      },
    },
    trial: {
      active: "You have {days} days left in the founding program.",
      ending_soon: "Your trial ends soon. Keep inventory updated to receive better leads.",
      expired: "The trial has ended. Contact AutoMapa to review results and next steps.",
      converted: "Your dealership completed the founding trial. Thank you for trusting AutoMapa.",
      declined: "The trial did not continue. Contact AutoMapa if you want to review options.",
      not_started: "You have not started the founding program yet.",
    },
    plan: {
      featuredUpgrade: "Your current plan does not include featured listings. Contact AutoMapa to review options.",
      descriptions: {
        free: "Basic presence and a limited trial for new dealerships.",
        starter: "Small plan for dealerships with moderate inventory.",
        growth: "Active plan with more leads, reports, and visibility.",
        premium: "High visibility, featured placement, and priority support.",
        custom: "Limits and terms configured manually by AutoMapa.",
      },
      warnings: {
        listing_limit: {
          message: "Your current plan allows up to {listingLimit} active listings. Contact AutoMapa about a higher plan to publish more vehicles.",
        },
        lead_limit: {
          message: "You've reached your plan's monthly lead limit. Contact AutoMapa to review options.",
        },
        lead_limit_near: {
          message: "You're close to your plan's monthly lead limit.",
        },
      },
    },
    onboardingChecklist: {
      business_name_confirmed: "Business name confirmed",
      public_name_confirmed: "Public name confirmed",
      logo_added: "Dealership logo/photo",
      address_confirmed: "Address confirmed",
      city_neighborhood_confirmed: "City/neighborhood confirmed",
      whatsapp_confirmed: "Primary WhatsApp confirmed",
      contact_person_confirmed: "Contact person confirmed",
      public_profile_reviewed: "Public profile reviewed",
      verification_reviewed: "Verification reviewed",
      inventory_file_received: "Inventory file received",
      inventory_imported: "Inventory imported",
      listings_cleaned: "Listings cleaned",
      listings_have_photos: "Listings with photos",
      listings_have_price_mileage: "Price and mileage complete",
      listings_confirmed_available: "Availability confirmed",
      min_ten_active_listings: "At least 10 active listings",
      lead_inbox_reviewed: "Lead inbox reviewed",
      whatsapp_routing_tested: "WhatsApp routing tested",
      dashboard_reviewed: "Dashboard reviewed",
      response_expectations_understood: "Response expectations explained",
      trial_terms_explained: "Trial terms explained",
      launch_ready_approval: "Launch-ready approval",
    },
  },
  leadDetail: {
    loading: "Loading lead…",
    notFound: "Lead not found.",
    backToInbox: "Back to inbox",
    back: "Back",
    openWhatsapp: "Open WhatsApp",
    unnamedLead: "Unnamed lead",
    hotPill: "Hot",
    buyer: "Buyer",
    name: "Name",
    email: "Email",
    city: "City",
    consent: "Consent",
    yes: "Yes",
    no: "No",
    purchaseIntent: "Purchase intent",
    temperature: "Temperature",
    budget: "Budget",
    vehicleType: "Vehicle type",
    transmission: "Transmission",
    fuel: "Fuel",
    financing: "Financing",
    downPayment: "Down payment",
    timeline: "Timeline",
    useCase: "Use",
    vehicleListing: "Vehicle / listing",
    viewPublic: "View public listing",
    editInventory: "Edit inventory",
    noLinkedVehicle: "No specific vehicle linked.",
    source: "Source",
    created: "Created",
    workflow: "Lead workflow",
    status: "Status",
    assignedSalesperson: "Assigned salesperson",
    salespersonPlaceholder: "Salesperson name",
    nextFollowUp: "Next follow-up",
    saveAssignment: "Save assignment",
    outcome: "Outcome",
    outcomeReason: "Reason / detail",
    outcomeReasonPlaceholder: "Required for low quality or spam",
    saveOutcome: "Save outcome",
    leadQuality: "Lead quality",
    rating: "Rating",
    selectPlaceholder: "Select…",
    saveRating: "Save rating",
    internalNotes: "Internal notes",
    notePlaceholder: "Add a note for the team…",
    addNote: "Add note",
    eventHistory: "Event history",
    whatsappPreview: "WhatsApp message preview",
    errors: {
      updateStatus: "Could not update status.",
      saveNote: "Could not save note.",
      saveOutcome: "Could not save outcome.",
      saveRating: "Could not save rating.",
      saveAssignment: "Could not save assignment.",
      invalidWhatsapp: "No valid WhatsApp number for this buyer.",
    },
  },
  buyerInterest: {
    title: "Buyer Interest",
    demandPanelTitle: "Inventory Demand",
    demandPanelIntro: "Aggregate saves, compares, and price-alert signals on your inventory.",
    listingSectionTitle: "Buyer Interest",
    viewDemandPanel: "View full demand panel",
    backToInventory: "Back to inventory",
    privacyNote: "Counts are aggregated to protect buyer privacy.",
    loadError: "Could not load buyer interest.",
    likes: "Likes",
    compares: "Compares",
    watchers: "Price watchers",
    kpiLikes: "Likes on active inventory",
    kpiCompares: "Compare adds",
    kpiWatchers: "Active price-drop watchers",
    kpiRising: "Rising like velocity",
    topLikedVehicle: "Top liked vehicle",
    topFiveTitle: "Top 5 liked vehicles",
    emptyInventoryTitle: "No active inventory found",
    emptyInventoryBody:
      "Buyer interest will appear here when your active listings receive saves, compares, or price watchers.",
    emptyInterestTitle: "No buyer interest yet",
    emptyInterestBody:
      "When buyers save, compare, or watch your vehicles, aggregate insights will appear here.",
    belowThreshold: "Not enough data to show detailed counts yet.",
    demandLabel: "Demand signal",
    risingTrend: "Rising saves this week",
    refreshCounts: "Refresh counts",
    sortLabel: "Sort",
    statusLabel: "Status",
    statusAll: "All",
    colVehicle: "Vehicle",
    colPrice: "Price",
    colDemand: "Demand",
    colStatus: "Status",
    colActions: "Actions",
    prevPage: "Previous",
    nextPage: "Next",
    ranges: {
      "7d": "Last 7 days",
      "30d": "Last 30 days",
      all: "All time",
    },
    sort: {
      likes: "Most liked",
      compares: "Most compared",
      watches: "Most price watches",
      updated: "Recently updated",
      price: "Highest price",
    },
    demand: {
      noData: "Not enough data",
      lowInterest: "Low interest",
      moderateInterest: "Moderate interest",
      highInterest: "High interest",
      priceSensitive: "Price sensitive",
    },
    insights: {
      strongSaveActivity: "This listing has strong save activity.",
      watchingForLowerPrice: "Several buyers are watching this vehicle for a lower price.",
      highSavesLowContact: "High saves but low contact activity may indicate price sensitivity.",
      confirmAvailability:
        "This listing has high save volume. Consider confirming availability or reviewing the price.",
    },
  },
};
